const ADD_PROXY_REQUEST = "ADD_PROXY_REQUEST";
const ADD_PROXY_REQUEST_SUCCESS = "ADD_PROXY_REQUEST_SUCCESS";
const ADD_PROXY_REQUEST_FAILURE = "ADD_PROXY_REQUEST_FAILURE";
const EDIT_PROXY_REQUEST = "EDIT_PROXY_REQUEST";
const EDIT_PROXY_REQUEST_SUCCESS = "EDIT_PROXY_REQUEST_SUCCESS";
const EDIT_PROXY_REQUEST_FAILURE = "EDIT_PROXY_REQUEST_FAILURE";
const DELETE_PROXY_REQUEST = "DELETE_PROXY_REQUEST";
const DELETE_PROXY_REQUEST_SUCCESS = "DELETE_PROXY_REQUEST_SUCCESS";
const DELETE_PROXY_REQUEST_FAILURE = "DELETE_PROXY_REQUEST_FAILURE";
const GET_PROXIES_REQUEST = "GET_PROXIES_REQUEST";
const GET_PROXIES_REQUEST_SUCCESS = "GET_PROXIES_REQUEST_SUCCESS";
const GET_PROXIES_REQUEST_FAILURE = "GET_PROXIES_REQUEST_FAILURE";
const GET_PROXY_SETTINGS_REQUEST = "GET_PROXY_SETTINGS_REQUEST";
const GET_PROXY_SETTINGS_REQUEST_SUCCESS = "GET_PROXY_SETTINGS_REQUEST_SUCCESS";
const GET_PROXY_SETTINGS_REQUEST_FAILURE = "GET_PROXY_SETTINGS_REQUEST_FAILURE";
const UPDATE_PROXY_SETTING_REQUEST = "UPDATE_PROXY_SETTING_REQUEST";
const UPDATE_PROXY_SETTING_REQUEST_SUCCESS =
  "UPDATE_PROXY_SETTING_REQUEST_SUCCESS";
const UPDATE_PROXY_SETTING_REQUEST_FAILURE =
  "UPDATE_PROXY_SETTING_REQUEST_FAILURE";
const REFRESH_PROXY_REQUEST = "REFRESH_PROXY_REQUEST";
const REFRESH_PROXY_REQUEST_SUCCESS = "REFRESH_PROXY_REQUEST_SUCCESS";
const REFRESH_PROXY_REQUEST_FAILURE = "REFRESH_PROXY_REQUEST_FAILURE";

export {
  ADD_PROXY_REQUEST,
  ADD_PROXY_REQUEST_SUCCESS,
  ADD_PROXY_REQUEST_FAILURE,
  DELETE_PROXY_REQUEST,
  DELETE_PROXY_REQUEST_SUCCESS,
  DELETE_PROXY_REQUEST_FAILURE,
  EDIT_PROXY_REQUEST,
  EDIT_PROXY_REQUEST_SUCCESS,
  EDIT_PROXY_REQUEST_FAILURE,
  GET_PROXIES_REQUEST,
  GET_PROXIES_REQUEST_SUCCESS,
  GET_PROXIES_REQUEST_FAILURE,
  GET_PROXY_SETTINGS_REQUEST,
  GET_PROXY_SETTINGS_REQUEST_SUCCESS,
  GET_PROXY_SETTINGS_REQUEST_FAILURE,
  UPDATE_PROXY_SETTING_REQUEST,
  UPDATE_PROXY_SETTING_REQUEST_SUCCESS,
  UPDATE_PROXY_SETTING_REQUEST_FAILURE,
  REFRESH_PROXY_REQUEST,
  REFRESH_PROXY_REQUEST_SUCCESS,
  REFRESH_PROXY_REQUEST_FAILURE,
};
